import { toast } from 'sonner';

let lastToastTime = 0;

/**
 * Check a fetch Response for 429 ai_budget_exceeded.
 * Shows a toast (throttled to once per 30s) and returns true if budget was exceeded.
 */
export async function isAiBudgetExceeded(response: Response): Promise<boolean> {
    if (response.status !== 429) return false;

    try {
        const cloned = response.clone();
        const data = await cloned.json();
        if (data?.error === 'ai_budget_exceeded') {
            const now = Date.now();
            if (now - lastToastTime > 30_000) {
                lastToastTime = now;
                toast.error("You've used your daily AI tokens. They reset at midnight.");
            }
            window.dispatchEvent(new CustomEvent('ai-action-complete'));
            return true;
        }
    } catch {
        // Not JSON or unexpected format
    }
    return false;
}
